import { connect } from 'react-redux'
import Globals from '../../../globals'
import * as action from '../../state/detail/action'
import * as tabCommentsAction from '../../state/detail/tab-comments/action'
import * as selector from '../../state/detail/selector'
import * as tabCommentsSelector from '../../state/detail/tab-comments/selector'
import Customer from './Customer'
import {
    selectCanReassignStore,
    selectCanSeeImages,
    selectHasRole,
} from '../../../security/state/auth/selector'
import { callNumber } from '../../../sipgate/state/action'
import { ROLE_PARTNER_PHYSICIAN } from '../../../security/state/auth/const'
import { COUNTRY_CODE_LIST, LANGUAGE_LIST } from '../../../internationalization/const'
import { selectCanReassignPhysician } from '../../../security/state/auth/selector'

const mapStateToProps = (state, props) => {
    return {
        customer: selector.selectCustomer(state),
        accountFix: selector.selectAccountFix(state),
        imageFetching: selector.selectImageFetching(state),
        startProcessFetching: selector.selectStartProcessFetching(state),
        canReassignPhysician: selectCanReassignPhysician(state),
        showImages: selector.selectShowImages(state),
        customerId: props.computedMatch.params.customerId,
        changeEmailData: selector.selectChangeEmailData(state),
        salutationList: Globals.selector.selectSalutationList(state),
        canSeeImages: selectCanSeeImages(state),
        physicianList: Globals.selector.selectPhysicianList(state),
        supplierList: Globals.selector.selectSupplierList(state),
        isExternalTreatmentPlanerPossible: selector.selectIsExternalTreatmentPlanerPossible(
            state
        ),
        treatmentPlanerList: Globals.selector.selectTreatmentPlanerList(state),
        userList: Globals.selector.selectUserList(state),
        readOnly: selectHasRole(state, ROLE_PARTNER_PHYSICIAN),
        processList: selector.selectProcessList(state),
        tab: selector.selectTab(state),
        countryCodeList: COUNTRY_CODE_LIST,
        languageList: LANGUAGE_LIST,
        responseFeedback: selector.selectResponseFeedback(state),
        deleteConfirmationModal: selector.selectDeleteConfirmationModal(state),
        storeList: Globals.selector.selectStoreList(state),
        canReassignStore: selectCanReassignStore(state),
        contact: selector.selectCustomerContact(state),
        error: selector.selectCustomerError(state),

        // comments tab
        processInstanceList: tabCommentsSelector.selectProcessInstanceList(state),
        commentText: tabCommentsSelector.selectCommentText(state),
        isInternal: tabCommentsSelector.selectIsInternal(state),
        currentUser: Globals.selector.selectUser(state),
    }
}

const mapDispatchToProps = {
    findCustomer: action.findCustomer,
    reassignPhysician: action.reassignPhysician,
    reassignStore: action.reassignStore,
    changeCustomer: action.changeCustomer,
    saveCustomer: action.saveCustomer,
    toggleImageView: action.toggleImageView,
    uploadCustomerImage: action.uploadCustomerImage,
    fixAccountProblem: action.fixAccountProblem,
    callNumber,
    openChangeEmailModal: action.openChangeEmailModal,
    closeChangeEmailModal: action.closeChangeEmailModal,
    changeNewEmail: action.changeNewEmail,
    changeEmail: action.changeEmail,
    startRefinementSetProcess: action.startRefinementSetProcess,
    startRefinementShopProcess: action.startRefinementShopProcess,
    startRetainerRefinementProcess: action.startRetainerRefinementProcess,
    startEscalationProcess: action.startEscalationProcess,
    findProcessComment: action.findProcessComment,
    startAlignerReproductionProcess: action.startAlignerReproductionProcess,
    startPartialRefundProcess: action.startPartialRefundProcess,
    changeActiveTab: action.changeActiveTab,
    startDownloadCustomerData: action.startDownloadCustomerData,
    closeResponseFeedbackModal: action.closeResponseFeedbackModal,
    openDeleteConfirmationModal: action.openDeleteConfirmationModal,
    closeDeleteConfirmationModal: action.closeDeleteConfirmationModal,
    handleDeleteConfirmationModal: action.handleDeleteConfirmationModal,
    deleteCustomer: action.deleteCustomer,
    showError: action.showError,
    updateWhatsappOtpIn: action.updateWhatsappOtpIn,
    changeCustomerContact: action.changeCustomerContact,
    saveCustomerContact: action.saveCustomerContact,
    hydrateContact: action.hydrateCustomerContact,
    changeIsTransferredToDrSmile: action.changeIsTransferredToDrSmile,

    // comments tab
    findProcessCommentList: tabCommentsAction.findProcessComment,
    changeProcessComment: tabCommentsAction.changeProcessComment,
    addProcessComment: tabCommentsAction.commentProcessInstance,
    changeIsCommentInternal: tabCommentsAction.changeIsCommentInternal,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Customer)



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/CustomerContainer.js